import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface WhoAmIResponse extends BackendResponse, WhoAmIInfo {}

export interface WhoAmIParameters extends NextApiParams {}

export const whoAmI = withNextApi<WhoAmIResponse, WhoAmIParameters>("/auth/WhoAmI", {
  method: "GET",
});

export interface WhoAmIInfo {
  concernId: number | null;
  nVerifiedProfilesInConcern: number;
  hasVerifiedProfileInConcerns: number[];
  usernameFromIdentityProvider: string;
  emailFromIdentityProvider: string;
  provider: string;
  cvpIdp?: string | null;
  userIdFromIdentityProvider: string;
  idCandidate?: number;
  hasCvpToken: boolean;
  cvpTokenRejectionReason?: string | null;
  activeProfileEmail?: string | null;
  selectedProfileInConcernForThisSession: number | null;
  selectedVerifiedProfileInConcernForThisSession: number | null;
  selectedUnverifiedProfileInConcernForThisSession: number | null;
  details: WhoAmIExtraInfo;

  /**
   * Do not use this value directly for translating.
   * Instead use the hook useEvaluatedLocale.
   */
  locale?: string;
  environment?: string;
}

export interface WhoAmIExtraInfo {
  concernName: string;
  candidateId: number | null;
  concernId: number;
}
